import React, { useEffect, useState, useRef } from 'react';
import { API, Endpoints } from '../api/API';
import { Facility, init_Facility } from '../interfaces/Interfaces';
import { verifyZip, checkTrailingSpace } from '../js/verificationFunctions';

interface FacilitySearchProps {
    formStep: number,
    setFormStep: React.Dispatch<React.SetStateAction<number>>,
    facilityInfo: Facility,
    setFacilityInfo: (arg0: Facility) => void,
    facZip: string,
    facilityOptional: boolean,
    appFeatures: any,
    userCountry: string | null,
    accountNum: string,
    userType: "customer" | "independent" | "student" | null,
    translate: () => void,
    setBackgroundWIP: React.Dispatch<React.SetStateAction<boolean>>,
    countries?: Record<string, string>,
    lang: string | null,
    token: string
}

const FacilitySearch = (props: FacilitySearchProps) => {
    const Other: Facility = {
        accountId: '',
        ean: 'Other',
        parentEAN: '',
        facilityName: '',
        facilityAddress: '',
        facilityCity: '',
        facilityState: '',
        facilityZip: '',
        facilityCountry: '',
        isActive: '',
        reltio_UpdatedOn: '',
        reltio_CreatedOn: '',
        updatedOn: '',
        version: ''
    };

    // State maintains list of facilities returned by API call
    const [facilitiesFromSearch, setFacilitiesFromSearch] = useState<Array<Facility>>([Other]);
    const [requiredInfoError, setRequiredInfoError] = useState<Array<string>>([]);
    const [validationError, setValidationError] = useState<Array<string>>([]);
    const [selectedValue, setSelectedValue] = useState('');
    const selectRef = useRef<HTMLSelectElement>(null);

    // Api call is made once when this component is first rendered
    useEffect(() => {
        getFacilities();
    }, []);
    useEffect(() => {
        getFacilities();
    }, [props.facZip, props.accountNum]);

    const handleFacilityChange = (event: any) => {
        const facValue = event.target.value;
        setSelectedValue(facValue);
        getFacility(facValue);
    }

    useEffect(() => {
            if (props.accountNum != "") {
                console.log('props.accountNum is there : ' + props.accountNum);
                if (facilitiesFromSearch != undefined && facilitiesFromSearch.length > 0) {
                    const validFac = facilitiesFromSearch.find(x => x.ean == props.accountNum);
                    if (validFac) {
                        setSelectedValue(JSON.stringify(validFac));
                        if (selectRef.current) {
                            console.log('current selectref found..');
                            const event = new Event('change', { bubbles: true });
                            selectRef.current?.dispatchEvent(event);
                        }
                    }
                }
            }
            else {
                console.log('props.accountNum is NOT there');
                if (init_Facility.ean !== "Oter") {
                    setSelectedValue(JSON.stringify(init_Facility));
                }
                else {
                    setSelectedValue(JSON.stringify(Other));
                }
            }
    
        }, [props.accountNum, facilitiesFromSearch]);

    useEffect(() => {
        props.translate();

        const indexOfSelectedFacility = facilitiesFromSearch.findIndex(facOption => facOption.ean === props.facilityInfo.ean && facOption.facilityName === props.facilityInfo.facilityName);

        if (indexOfSelectedFacility === -1) {
            props.setFacilityInfo({ ...init_Facility });
        }
    }, [props.lang, facilitiesFromSearch]);

    useEffect(() => {
        $('.match-height').matchHeight();
    }, [requiredInfoError]);

    const getFacilities = async () => {
        
        if(props.facZip === '' && props.accountNum == ''){
            props.setFacilityInfo({ ...init_Facility });
            setFacilitiesFromSearch([Other]);
            return;
        }
        props.setBackgroundWIP(true);
        if (props.facilityInfo.facilityZip !== '' && props.facZip !== props.facilityInfo.facilityZip) {
            props.setFacilityInfo({ ...init_Facility });
        }
        let country = "";
        if (props.appFeatures?.limitOrgSearchToCountry) {
            country = props.userCountry ?? "";
        }
        var body;
        if(props.accountNum != ""){
            console.log('acc present fac search..');
            body = { "ean": props.accountNum}
        }
        else{
            body = { "zipCode": props.facZip.toUpperCase(), "ean": props.accountNum, "country": country }
        }

        //const body = { "zipCode": props.facZip.toUpperCase(), "ean": props.accountNum, "country": country }
        // const data =  await getFacilitiesApi(body);
        const data = await API.POST(body, Endpoints.GetFacilities, props.token);
        data.push(Other);
        setFacilitiesFromSearch(data);
        props.setBackgroundWIP(false);
    }

    const goBack = () => {
        props.setFormStep(props.formStep - 1);
    }

    const goNext = () => {
        var currentErrors: Array<string> = [];
        var validationFlag = false;

        if (props.facilityInfo.facilityZip && !verifyZip(props.facilityInfo.facilityZip)) {
            console.log("zip verifies in step 3")
            currentErrors = [...currentErrors, "facZipCode"];
            validationFlag = true;
        }

        setValidationError([...currentErrors]);

        if (validationFlag || (props.userType !== "independent" && !props.facilityOptional && ((props.facilityInfo.ean === "Other" || props.facilityInfo.ean === "" ) && (props.facilityInfo.facilityName === "" || props.facilityInfo.facilityAddress === "" || props.facilityInfo.facilityCity === "" || props.facilityInfo.facilityState === "" || props.facilityInfo.facilityZip === "" || props.facilityInfo.facilityCountry === "")))) {
            currentErrors = [];            
            // Always check for EAN
            if (!props.facilityInfo.ean && !currentErrors.includes("ean")) {
                currentErrors.push("facilitySelect");
            }

            // If EAN is 'Other', check additional fields
            if (props.facilityInfo.ean === 'Other') {
                if (!props.facilityInfo.facilityName && !currentErrors.includes("facName")) currentErrors.push("facName");
                if (!props.facilityInfo.facilityAddress && !currentErrors.includes("facAddress")) currentErrors.push("facAddress");
                if (!props.facilityInfo.facilityCity && !currentErrors.includes("facCity")) currentErrors.push("facCity");
                if (!props.facilityInfo.facilityState && !currentErrors.includes("facState")) currentErrors.push("facState");
                if (!props.facilityInfo.facilityZip && !currentErrors.includes("facZipCode")) currentErrors.push("facZipCode");
                if (!props.facilityInfo.facilityCountry && !currentErrors.includes("facCountry")) currentErrors.push("facCountry");
            }

            if (currentErrors.length > 0) {
                setRequiredInfoError(currentErrors);
            } else {
                setRequiredInfoError([]);
                props.setFormStep(props.formStep + 1);
            }

        } else {            
            setRequiredInfoError([]);
            props.setFormStep(props.formStep + 1);
        }
    }

    const getFacility = (event: any) => {
        let fac = JSON.parse(event);
        setTimeout(() => {
            props.setFacilityInfo({ ...fac });    
        }, 500);
    }

    return (
        <div id="facility-information">
            <form className="facilitySearch-form" action="javascript:void(0);">
                <p className="21680e21-05a8-425d-8ff5-d04cb61ba812"> Please select a facility from the list below. If your facility is not found, select "Other" and enter the details of your facility manually.</p>
                <p className={requiredInfoError.length === 0 ? "hide" : "accent-1-text"}>
                    <i className="fa fa-exclamation-circle" aria-hidden="true"></i>
                    &nbsp;<span className="664eebfb-9b9d-488f-9778-2f09ffa5f99b">Please provide your</span> {requiredInfoError.map((value, index) => { return index === 0 ? $(`#${value}`).attr('placeholder') : ', ' + $(`#${value}`).attr('placeholder'); })}
                </p>
                <p className={validationError.includes("facAddress") && !requiredInfoError.includes("facAddress") ? "accent-1-text" : "hide"}>
                    <i className="fa fa-exclamation-circle" aria-hidden="true"></i>
                    &nbsp;<span className="9032d2e1-b597-49e8-a827-e7f8f412f4fd">Please ensure your facility address is a valid address.</span>
                </p>
                <p className={validationError.includes("facAddress2") ? "accent-1-text" : "hide"}>
                    <i className="fa fa-exclamation-circle" aria-hidden="true"></i>
                    &nbsp;<span className="9032d2e1-b597-49e8-a827-e7f8f412f4fd">Please ensure your facility address 2 is a valid address.</span>
                </p>
                <p className={validationError.includes("facCity") && !requiredInfoError.includes("facCity") ? "accent-1-text" : "hide"}>
                    <i className="fa fa-exclamation-circle" aria-hidden="true"></i>
                    &nbsp;<span className="9032d2e1-b597-49e8-a827-e7f8f412f4fd">Please ensure your facility city is a valid city name.</span>
                </p>
                <p className={validationError.includes("facState") && !requiredInfoError.includes("facState") ? "accent-1-text" : "hide"}>
                    <i className="fa fa-exclamation-circle" aria-hidden="true"></i>
                    &nbsp;<span className="9032d2e1-b597-49e8-a827-e7f8f412f4fd">Please ensure your facility state is a valid state name.</span>
                </p>
                <p className={validationError.includes("facZipCode") && !requiredInfoError.includes("facZipCode") ? "accent-1-text" : "hide"}>
                    <i className="fa fa-exclamation-circle" aria-hidden="true"></i>
                    &nbsp;<span className="9032d2e1-b597-49e8-a827-e7f8f412f4fd">Please ensure your facility zipcode contains only numbers and hyphens.</span>
                </p>
                <p className={validationError.includes("facCountry") && !requiredInfoError.includes("facCountry") ? "accent-1-text" : "hide"}>
                    <i className="fa fa-exclamation-circle" aria-hidden="true"></i>
                    &nbsp;<span className="9032d2e1-b597-49e8-a827-e7f8f412f4fd">Please ensure your facility country is a valid country name.</span>
                </p>
                <div className="row">
                    <div className="col-sm-12">
                        <p><label className='7a1e14b4-695c-4b96-a23d-c9c14e078c8e requiredLabel'>Facility Name</label><span className='requiredIcon'> *</span>
                            <select name="facilitySelect" id="facilitySelect" placeholder="Facility" style={{display:'block'}} ref={selectRef} value={selectedValue} onChange={handleFacilityChange}>
                                {
                                    (props.accountNum != "" && facilitiesFromSearch.length == 2) ? <></> : <option value={JSON.stringify(init_Facility)} selected hidden disabled className="7a1e14b4-695c-4b96-a23d-c9c14e078c8e"> Facility Name </option>
                                }
                                {facilitiesFromSearch.map(
                                    (fac: Facility) => (
                                        <option className={fac.ean === 'Other' ? "afde582f-1be5-4568-a6d2-fb5a67d60524" : ""} value={JSON.stringify(fac)}> {fac.ean !== 'Other' ? `${fac.facilityName} (${fac.facilityAddress})` : "Other"} </option>
                                    )
                                )}
                            </select>
                        </p>
                    </div>
                </div>

                <div className="row">
                    <div className="col-sm-6">
                        <p>
                            <label className='7a1e14b4-695c-4b96-a23d-c9c14e078c8e requiredLabel'>Facility Name</label><span className='requiredIcon'> *</span>
                            <input
                                type='text'
                                readOnly={props.facilityInfo.ean === "Other" ? false : true}
                                placeholder="Facility Name"
                                id='facName'
                                className={validationError.includes("facName") || requiredInfoError.includes("facName") ? 'error 7a1e14b4-695c-4b96-a23d-c9c14e078c8e' : '7a1e14b4-695c-4b96-a23d-c9c14e078c8e'}
                                value={props.facilityInfo.facilityName}
                                onChange={(e) => props.setFacilityInfo({ ...props.facilityInfo, facilityName: e.target.value })}
                                onBlur={checkTrailingSpace(
                                    (e) => props.setFacilityInfo({ ...props.facilityInfo, facilityName: e.target.value })
                                )}
                            />
                        </p>
                    </div>
                    <div className="col-sm-6">
                        <p>
                            <label className="394830c0-8428-4660-80b2-a95b0b248aff requiredLabel">Facility Address</label><span className='requiredIcon'> *</span>
                            <input
                                type="text"
                                readOnly={props.facilityInfo.ean === "Other" ? false : true}
                                placeholder="Facility Address"
                                id='facAddress'
                                className={validationError.includes("facAddress") || requiredInfoError.includes("facAddress") ? 'error 394830c0-8428-4660-80b2-a95b0b248aff' : '394830c0-8428-4660-80b2-a95b0b248aff'}
                                value={props.facilityInfo.facilityAddress}
                                //no trailing space check for address because there are spaces in addresses
                                onChange={(e) => props.setFacilityInfo({ ...props.facilityInfo, facilityAddress: e.target.value })}
                            />
                        </p>
                    </div>
                </div>
                <div className="row">
                    <div className="col-sm-6">
                        <p>
                            <label className="76150a37-fca8-4dda-bd64-d3a5f828cfe1 requiredLabel">Facility City</label><span className='requiredIcon'> *</span>
                            <input
                                type='text'
                                readOnly={props.facilityInfo.ean === "Other" ? false : true}
                                placeholder="Facility City"
                                id='facCity'
                                className={validationError.includes("facCity") || requiredInfoError.includes("facCity") ? 'error 76150a37-fca8-4dda-bd64-d3a5f828cfe1' : '76150a37-fca8-4dda-bd64-d3a5f828cfe1'}
                                value={props.facilityInfo.facilityCity}
                                //ditto for city
                                onChange={(e) => props.setFacilityInfo({ ...props.facilityInfo, facilityCity: e.target.value })}
                            />
                        </p>
                    </div>
                    <div className="col-sm-6">
                        <p>
                            <label className="032b99bd-57b5-4afc-94bf-f6bd5da9fb49 requiredLabel">Facility State/ Province</label><span className='requiredIcon'> *</span>
                            <input
                                type='text'
                                readOnly={props.facilityInfo.ean === "Other" ? false : true}
                                placeholder="Facility State/ Province"
                                id='facState'
                                className={validationError.includes("facState") || requiredInfoError.includes("facState") ? 'error 032b99bd-57b5-4afc-94bf-f6bd5da9fb49' : '032b99bd-57b5-4afc-94bf-f6bd5da9fb49'}
                                value={props.facilityInfo.facilityState}
                                //ditto for state
                                onChange={(e) => props.setFacilityInfo({ ...props.facilityInfo, facilityState: e.target.value })}
                            />
                        </p>
                    </div>
                </div>
                <div className="row">
                    <div className="col-sm-6">
                        <p>
                            <label className="bf996cf8-5aa3-40e0-97b7-05ec72e8012b requiredLabel">Facility Zip/ Postal Code</label><span className='requiredIcon'> *</span>
                            <input
                                type='text'
                                readOnly={props.facilityInfo.ean === "Other" ? false : true}
                                placeholder="Facility Zip/ Postal Code"
                                id='facZipCode'
                                className={validationError.includes("facZipCode") || requiredInfoError.includes("facZipCode") ? 'error bf996cf8-5aa3-40e0-97b7-05ec72e8012b' : 'bf996cf8-5aa3-40e0-97b7-05ec72e8012b'}
                                value={props.facilityInfo.facilityZip}
                                onChange={checkTrailingSpace(
                                    (e) => props.setFacilityInfo({ ...props.facilityInfo, facilityZip: e.target.value })
                                )}
                            />
                        </p>
                    </div>
                    <div className="col-sm-6">
                        <p>
                            <label className="8124a58b-63a7-4760-b5d5-a36ef042cb4d requiredLabel">Facility Country</label><span className='requiredIcon'> *</span>
                            <select
                                disabled={props.facilityInfo.ean === "Other" ? false : true}
                                placeholder="Facility Country"
                                id='facCountry'
                                className={validationError.includes("facCountry") || requiredInfoError.includes("facCountry") ? 'error' : ''}
                                value={props.facilityInfo.facilityCountry.toLowerCase()}
                                onChange={(e) => e ? props.setFacilityInfo({ ...props.facilityInfo, facilityCountry: e.target.value }) : null}
                            >
                                <option value="" disabled className='8124a58b-63a7-4760-b5d5-a36ef042cb4d'>Facility Country</option>
                                {props.countries ? (Object.keys(props.countries).map((key: string) => {
                                    return <option key={key} value={key}>{props.countries![key]}</option>
                                })) : <></>}
                            </select>
                        </p>
                    </div>
                </div>
            </form>
            <div className="spacer"></div>
            <p className="buttons">
                <button id="continue" className="button 394b58c5-ee63-4444-978a-c0373030b4f2" onClick={goNext} >Continue</button>
                <button className="gray button 041b8acf-fafc-450f-8111-d7d0c36bba6b" onClick={goBack}>Back</button>
            </p>
        </div>
    )
}

export default FacilitySearch;
